import React, { useCallback, useContext, useEffect, useState } from "react";
import { useConfig } from "./configContext";
import { AuthContext, AuthContextProps, AuthProvider, AuthProviderProps, AuthProviderUserManagerProps } from "react-oidc-context";

export const OidcAuthProvider = ({ children }) => {
    const [identityServerConfig, setIdentityServerConfig] = useState<AuthProviderProps>({} as AuthProviderProps);
    const config = useConfig();

    const getIdentityServer = useCallback(() => {
        config.identityServer &&
            setIdentityServerConfig({
                authority: config.identityServer.authority,
                client_id: config.identityServer.clientId,
                scope: config.identityServer.scope,
                redirect_uri: `${window.location.protocol}//${window.location.hostname + (window.location.port ? ':' + window.location.port : '')}/signin-oidc`,
                monitorSession: false,
                response_type: 'code'
            });
    }, [config.identityServer])

    useEffect(getIdentityServer, [getIdentityServer]);

    const onSigninCallback = () => {
        window.location.href = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
    }

    return (
        <>
            {identityServerConfig.authority &&
                <AuthProvider {...identityServerConfig} onSigninCallback={onSigninCallback}>
                    {children}
                </AuthProvider>}
        </>)
}

export default AuthContext;

export const useAuthContext = (): AuthContextProps | undefined => useContext(AuthContext);
